import { TriangleAlert } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const EarlyMedicationBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-warning font-semibold">
      <TriangleAlert aria-hidden className="size-3 shrink-0" />
      {t('component:badge.earlyMedication')}
    </Badge>
  );
};
